var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea",class:_vm.classesInput},[_c('textarea',_vm._g(_vm._b({ref:"input",staticClass:"input shadown",class:{ 'textarea-border-none' : _vm.borderNone, 'noscroll' : _vm.noScroll },style:({ 'color': _vm.colorText, 'min-height': _vm.inputMinHeight + 'px', 'max-height': _vm.inputMaxHeight + 'px' }),attrs:{"id":_vm.identify,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),{
      ..._vm.$listeners,
      input: event => _vm.$emit('input', event.target.value),
      mouseup: event => _vm.$emit('highlight', event)
    }))])
}
var staticRenderFns = []

export { render, staticRenderFns }